<template>
  <v-alert
    v-if="errored"
    :value="true"
    type="error"
  >We're sorry, we're not able to retrieve this information at the moment, please try again later.</v-alert>
  <v-flex v-else xs12 sm6 offset-sm3>
    <div id="dataContent" style="overflow:auto; height: calc(100vh - 64px);">
      <v-list two-line>
        <template v-for="(item, index) in meetings">
          <v-list-tile :key="item.name + item.id" avatar ripple @click="clicked(index)">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              <v-list-tile-sub-title
                class="text--primary"
              >{{moment(item.meeting_date).format('YYYY-MM-DD')}} {{item.topic}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="index + 1 < meetings.length" :key="index"></v-divider>
        </template>
      </v-list>
    </div>
  </v-flex>
</template>

<script>
/* eslint-disable */

import axios from "axios";
import swal from "sweetalert2";
import router from "../../router";

export default {
  name: "Meeting",
  data: () => ({
    meetings: [],
    loading: true,
    errored: false
  }),
  mounted() {
    this.checkLoggedIn();
  },
  methods: {
    checkLoggedIn() {
      if (!this.getUser()) {
        router.push("/auth");
      } else {
        axios
          .get(this.api_url + "/api/meeting/", {
            headers: { Authorization: `JWT ${this.getUser().token}` }
          })
          .then(response => {
            this.meetings = response.data;
            console.log(this.meetings);
          })
          .catch(error => {
            if (error.response.status === 401) {
              this.$session.destroy();
              this.$router.push("/auth");
            }
            console.log(error);
            this.errored = true;
          })
          .finally(() => (this.loading = false));
      }
    },
    clicked(index) {
      router.push({
        name: "OrganizerMeeting",
        params: { id: this.meetings[index].id }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Meeting.vue